import { useRouter } from "next/router";
import styles from "../../styles/components/searchFigma/ResultListMobile.module.css";

export default function ResultListMobile({
  parts,
  onOpenModal,
  onOpenModalMultiManufacturer,
  onOpenModalMultiDistributor,
}) {
  const router = useRouter();
  const { query } = router;

  // 총 부품 개수 계산
  const totalPartsCount = parts.reduce(
    (total, item) => total + (item.price?.length || 0),
    0
  );

  // URL 파라미터에서 정렬값 읽기
  const currentSort = query.sort || "all";

  // sort 값에 따른 표시 텍스트 매핑
  const sortLabelMap = {
    all: "메타서치",
    day: "납기순",
    qty: "재고순",
    keyword: "검색어만",
  };

  const currentSortLabel = sortLabelMap[currentSort] || "메타서치";

  // ----------------------------------------------------
  // 🔥 제조사 / 유통사 텍스트를 URL 기반으로 계산
  // ----------------------------------------------------
  const getLabelByQuery = (value, defaultLabel) => {
    if (!value) return defaultLabel;

    const decoded = decodeURIComponent(value);
    const list = decoded.split(",");

    if (list.length === 0) return defaultLabel;
    if (list.length === 1) return list[0];
    return `다중선택`;
  };
  const getLabelLength = (value) => {
    if (!value) return "";

    const decoded = decodeURIComponent(value);
    const list = decoded.split(",");

    // 하나면 표시 안 함
    if (list.length === 1) return "";

    // 여러 개면 숫자만 표시
    return `${list.length}`;
  };

  const manufacturerLabel = getLabelByQuery(query.manufacturer, "제조사 선택");
  const manufacturerLength = getLabelLength(query.manufacturer, "");

  const distributorLabel = getLabelByQuery(query.source, "유통사 선택");
  const distributorLength = getLabelLength(query.source, "");

  return (
    <div className={styles.searchResultOptionGroup}>
      <div className={styles.searchResultGroup}>
        <div className={styles.searchResult}>
          <div className={`${styles.searchResultText} body1`}>검색결과</div>
          <div className={`${styles.searchResultCount} caption2`}>
            총 {totalPartsCount}건
          </div>
        </div>

        {/* 현재 정렬 상태 표시 */}
        <div className={styles.buttonText} onClick={onOpenModal}>
          <div className={`${styles.iconvText} caption2`}>
            {currentSortLabel}
          </div>
          <div className={styles.iconvIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12.7071 5.29295C13.0976 5.68348 13.0976 6.31649 12.7071 6.70702L8.70711 10.707C8.51957 10.8946 8.26529 11 8.00008 11C7.73486 11 7.48058 10.8946 7.29304 10.707L3.29304 6.70702C2.90252 6.31649 2.90252 5.68348 3.29304 5.29295C3.68357 4.90243 4.31658 4.90243 4.70711 5.29295L8.00008 8.58592L11.293 5.29295C11.6836 4.90243 12.3166 4.90243 12.7071 5.29295Z"
                fill="#2F2F2F"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className={styles.optionGroup}>
        <div
          className={styles.manufacturerText}
          onClick={onOpenModalMultiManufacturer}
        >
          {manufacturerLabel}
          <span className={`${styles.redColor} caption1`}>
            {distributorLength}
          </span>
        </div>
        <div
          className={styles.manufacturerIcon}
          onClick={onOpenModalMultiManufacturer}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M12.7071 5.29295C13.0976 5.68348 13.0976 6.31649 12.7071 6.70702L8.70711 10.707C8.51957 10.8946 8.26529 11 8.00008 11C7.73486 11 7.48058 10.8946 7.29304 10.707L3.29304 6.70702C2.90252 6.31649 2.90252 5.68348 3.29304 5.29295C3.68357 4.90243 4.31658 4.90243 4.70711 5.29295L8.00008 8.58592L11.293 5.29295C11.6836 4.90243 12.3166 4.90243 12.7071 5.29295Z"
              fill="#2F2F2F"
            />
          </svg>
        </div>
        <div
          className={styles.manufacturerText}
          onClick={onOpenModalMultiDistributor}
        >
          {distributorLabel}
          <span className={`${styles.redColor} caption1`}>
            {distributorLength}
          </span>
        </div>
        <div className={styles.brandIcon} onClick={onOpenModalMultiDistributor}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M12.7071 5.29295C13.0976 5.68348 13.0976 6.31649 12.7071 6.70702L8.70711 10.707C8.51957 10.8946 8.26529 11 8.00008 11C7.73486 11 7.48058 10.8946 7.29304 10.707L3.29304 6.70702C2.90252 6.31649 2.90252 5.68348 3.29304 5.29295C3.68357 4.90243 4.31658 4.90243 4.70711 5.29295L8.00008 8.58592L11.293 5.29295C11.6836 4.90243 12.3166 4.90243 12.7071 5.29295Z"
              fill="#2F2F2F"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
